/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import * as appStrings from '@touchplan/strings';
import { EMPTY, of, Subject } from 'rxjs';
import { filter, map, switchMap, takeUntil } from 'rxjs/operators';
import { IApplicationWideMessage } from 'src/app/app-data/models/ApplicationWideMessage';
import { GenericDialogComponent } from '../../generic-dialog/generic-dialog.component';
import { BannerMessageHandler } from '../../logging/banner-message-handler';
import { ApplicationWideMessageService } from '../services/application-wide-message.service';

@Component({
	selector: 'app-application-wide-message',
	template: '',
})
export class ApplicationWideMessageComponent implements OnInit, OnDestroy {
	private destroy$ = new Subject<void>();

	constructor(
		private appWideMessageService: ApplicationWideMessageService,
		private bannerMessageHandler: BannerMessageHandler,
		private dialog: MatDialog
	) {}

	public ngOnInit(): void {
		this.appWideMessageService
			.getAppWideMessage()
			.pipe(
				filter(Boolean),
				switchMap(({ message, popupMessage }: IApplicationWideMessage) => {
					if (!!popupMessage) {
						return this.bannerMessageHandler
							.displayInfoMessage(message, appStrings.UICONTROL_TEXT_DETAILS.toUpperCase())
							.afterDismissed()
							.pipe(
								switchMap(({ dismissedByAction }) => {
									if (dismissedByAction) {
										return of(popupMessage);
									} else {
										return EMPTY;
									}
								})
							);
					} else {
						return this.bannerMessageHandler
							.displayInfoMessage(message)
							.afterDismissed()
							.pipe(switchMap(() => EMPTY));
					}
				}),
				takeUntil(this.destroy$)
			)
			.subscribe((message) => this.openPopupMessageDialog(message));
	}

	private openPopupMessageDialog(content: string) {
		this.dialog.open(GenericDialogComponent, {
			data: {
				content,
				yesButtonText: appStrings.UICONTROL_TEXT_CLOSE.toUpperCase(),
			},

			disableClose: true,
		});
	}

	public ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}
}
